import { render, staticRenderFns } from "./MapaPontos.vue?vue&type=template&id=3949167a&scoped=true&lang=pug&"
import script from "./MapaPontos.vue?vue&type=script&lang=js&"
export * from "./MapaPontos.vue?vue&type=script&lang=js&"
import style0 from "./MapaPontos.vue?vue&type=style&index=0&id=3949167a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949167a",
  null
  
)

export default component.exports